var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-navigation-drawer',{attrs:{"app":"","clipped":"","width":"260"},model:{value:(_vm.showDrawer),callback:function ($$v) {_vm.showDrawer=$$v},expression:"showDrawer"}},[_c('div',{staticClass:"padTop"},[_c('menu-list',{attrs:{"navigation":_vm.navigationItems}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }